import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './GST.scss';
import AnimakitExpander from "animakit-expander";

import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import SearchSelectMenu from '../../UI/SearchSelectMenu/SearchSelectMenu';

import AddonsWrapper from '../../UI/Wrappers/AddonsWrapper/AddonsWrapper';
import AddonsHeader from '../../UI/Headers/AddonsHeader/AddonsHeader';
import AddonsContent from '../../UI/Contents/AddonsContent/AddonsContent';
import AddonsImage from '../AddonsImage/AddonsImage';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

import mobileMapping from '../../../assets/json/mobileMapping';

import gstImage from '../../../assets/images/gst.svg';

import Divider from '../../UI/Divider/Divider';
import Button from '../../UI/Button/Button';
import TextLink from '../../UI/TextLink/TextLink';
import * as uiActions from '../../../store/actions/index';
import * as farePriceActions from '../../../store/actions/index'

class GST extends Component {
    state = {
        selectedOption: {
            value : "91",
            label : "+ 91"
        }
    }

    inputChangeHandler = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.props.onSetGstDetails(name, value);
    }

    handleChange = (selectedOption) => {
        const optionSelected = {...selectedOption};
        optionSelected.label = "+ " + optionSelected.value;
        this.setState({ selectedOption: optionSelected });
    }

    render() {
        return (
            <AddonsWrapper>
                <AddonsHeader>
                    <div className={`u-flex`}>
                        <AddonsImage image={gstImage} alt='Insurance'/>
                        <div>
                            <div className="phone-mb-1">
                                {
                                    this.props.isGstAdded ? 
                                    <HeadingH2 size={16} weight="Medium" color="Dark">GST Number applied: &nbsp;<span className="u-textColorGreen">{this.props.gstNumber}</span></HeadingH2> : 
                                    <HeadingH2 size={16} weight="Medium" color="Dark">Add GST Details&nbsp;{this.props.isGstMandatory ? <span className="u-textColorRed u-fontWeightRegular">GST details are mandatory for SME Fare</span> : <span>(Optional)</span>}</HeadingH2>
                                }
                            </div>
                            <div>
                                {
                                    this.props.isGstAdded ? 
                                    <HeadingH3 size={13} weight="Regular" color="Normal">You can now claim credit of GST charges.</HeadingH3> : 
                                    <HeadingH3 size={13} weight="Regular" color="Normal">Claim credit of GST charges. Your taxes may get updated post submitting your GST details.</HeadingH3> 
                                }
                            </div>
                        </div>
                    </div>
                    {
                        this.props.expanded ? (
                            <div className="u-phoneHide">
                                <TextLink type='fill' onClick={() => this.props.onToggleGst()}>CANCEL</TextLink>
                            </div>
                        ) : (
                            this.props.isGstAdded ? (
                                <div>
                                    <TextLink type='fill' onClick={() => this.props.onToggleGst()}>EDIT</TextLink>&nbsp;&nbsp;&nbsp;<span className="u-textColorLight">|</span>&nbsp;&nbsp;&nbsp;<TextLink type='fill' onClick={() => this.props.onClearGstDetails()}>REMOVE</TextLink>
                                </div>
                            ) : (
                                <div className={classes.ButtonContainer}>
                                    <Button theme='OutlinePrimary' type='AddonSmall' onClick={() => this.props.onToggleGst()}>ADD</Button>
                                </div>
                            )
                        )
                    }
                </AddonsHeader>
                { this.props.expanded ? <Divider type='normal'/> : null }
                <AnimakitExpander
                    expanded={this.props.expanded}
                    duration={250}
                    align="top">
                    <AddonsContent type='gst'>
                        <div className={`${classes.Container} u-flex f-row u-width100Percent phone-pl-0 phone-f-column`}>
                            <div className={`u-flex justify-content-between f-1 f-wrap phone-f-column`}>
                                <div className={classes.InputContainer}>
                                    <InputMaterial
                                        type='text'
                                        label='GST Number' 
                                        alignment='left' 
                                        onChange={this.inputChangeHandler} 
                                        value={this.props.gstNumber} 
                                        name='gstNumber'/>
                                </div>
                                <div className={classes.InputContainer}>
                                    <InputMaterial 
                                        type='text'
                                        label='Company Name'
                                        alignment='left' 
                                        onChange={this.inputChangeHandler} 
                                        value={this.props.companyName} 
                                        name='companyName'/>
                                </div>
                                <div className={classes.InputContainer}>
                                    <InputMaterial
                                        type='email'
                                        label='Email ID' 
                                        alignment='left' 
                                        onChange={this.inputChangeHandler} 
                                        value={this.props.email} 
                                        name='email'/>
                                </div>
                                <div className={classes.InputContainer}>
                                    <div className={`u-flex align-items-center u-relative mr-3 u-height100Percent`} style={{flex: '0 0 5rem'}}>
                                        <SearchSelectMenu 
                                            value={this.state.selectedOption}
                                            options={mobileMapping} 
                                            onChange={this.handleChange} 
                                            placeholder='ISD Code' />
                                    </div>
                                    <div className="u-width100Percent">
                                        <InputMaterial
                                            type='number'
                                            label='Mobile Number' 
                                            alignment='left' 
                                            onChange={this.inputChangeHandler} 
                                            value={this.props.mobileNumber} 
                                            name='mobileNumber'/>
                                    </div>
                                </div>
                            </div>
                            <div className={`${classes.Secondary} u-flex align-items-end justify-content-end phone-align-items-center`}>
                                <div className="u-phoneShow mr-5">
                                    <TextLink type='fill' onClick={() => this.props.onToggleGst()}>CANCEL</TextLink>
                                </div>
                                <Button onClick={() => {
                                    this.props.onAddGst();
                                    this.props.onCloseGst();
                                }} theme='OutlinePrimary' type='Gst'>{this.props.isGstAdded && this.props.expanded ? 'Update' : 'Submit'}</Button>
                            </div>
                        </div>
                        <div className={`${classes.GstTerms} mt-2`}>
                            <div className="mb-1"><h3 className="u-fontSize13 u-fontWeightMedium u-textColorDark">Disclaimer</h3></div>
                            <div className="u-fontSize11 u-fontWeightRegular u-textColorDark">
                                <p className="u-flex mb-2">
                                    <div>
                                        <span className={classes.square}></span>
                                    </div>
                                    <span>Correct GST details are madatory to book SME fare, In case of wrong GST details, Airline reserves the full right to cancel your booking without any prior intimation.</span>
                                </p>
                                <p className="u-flex">
                                    <div>
                                        <span className={classes.square}></span>
                                    </div>
                                    <span>As per Govt. Guidelines, GST Details should be mandatory and End-Consumer not your Agency.</span>
                                </p>
                            </div>    
                        </div>
                    </AddonsContent>
                </AnimakitExpander>
            </AddonsWrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        expanded: state.ui.isGstExpanded,
        gstNumber: state.farePrice.gstNumber,
        companyName: state.farePrice.companyName,
        email: state.farePrice.email,
        mobileNumber: state.farePrice.mobileNumber,
        isGstAdded: state.farePrice.isGstAdded,
        isGstMandatory: state.farePrice.isGstMandatory
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleGst: () => dispatch(uiActions.toggleGst()),
        onCloseGst: () => dispatch(uiActions.closeGst()),
        onSetGstDetails: (name, value) => dispatch(farePriceActions.setGstDetails(name, value)),
        onClearGstDetails: () => dispatch(farePriceActions.clearGstDetails()),
        onAddGst: () => dispatch(farePriceActions.addGst())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GST);


// WEBPACK FOOTER //
// ./src/components/Addons/GST/GST.js